import React from "react";
import styled from "styled-components";
import { breakpoints } from "theme/themes";

const OptionWrap = styled.div`
  background-color: ${(props) => (props.selected ? props.theme.colors.primary : "#fff")};
  color: ${(props) => (props.selected ? "#fff" : props.theme.colors.textDark)};
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 1rem;
  border-radius: 56px;
  transition: 300ms;
  font-size: 14px;
  margin: 1rem 0;

  &:hover {
    background-color: ${(props) => (props.selected ? props.theme.colors.primary : "#f9f9f9")};
  }

  @media${breakpoints.small} {
    font-size: 16px;
  }

  @media${breakpoints.xl} {
    font-size: 18px;
    margin: 2rem 0;
    padding-right: 2rem;
    border-radius: 999px;
  }

  @media${breakpoints.xl4} {
    font-size: 20px;
  }
`;

const IconWrap = styled.div`
  background-color: ${(props) => props.backgroundColor};
  border-radius: 50%;
  width: 48px;
  height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 1rem;
  font-size: 28px;
  flex-shrink: 0;

  svg {
    width: 24px ;
  }

  @media ${breakpoints.medium} {
    font-size: 48px;
    width: 80px;
    height: 80px;

    svg {
      width: 48px;
    }
  }
`;



const Option = ({ icon, iconType, iconBackground, text, selected = false, onClick }) => {

 
  const renderIcon = () => {
    if (iconType === 'svg' && (typeof icon === 'function')  ) {
      const Icon = icon;
      return <Icon />
    } else return icon
  }

  return (
    <OptionWrap className="option" selected={selected} onClick={onClick}>
      <IconWrap className="option-icon" backgroundColor={iconBackground}>
       {renderIcon()}
      </IconWrap>
      <div className="option-text">{text}</div>
    </OptionWrap>
  );
};

export default Option;
